import { useRef } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { usePageView } from 'src/hooks/use-page-view';
import { OverviewSingle } from 'src/sections/overview-single';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import TitleButton from 'src/components/ui/headers/title-button';
import PageSection from 'src/layouts/page-section';
import { nextNavigate, gotoListPage } from 'src/utils/navigation-utils';
import useToast from 'src/utils/toast-utils';

const Page = ({tmsObj, fuelObj, repairObj}) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const router = useRouter();
  const { toastMessage } = useToast();
  usePageView();

  return (
    <PageSection title="Censor" rootRef={rootRef}>
      <Grid
        container
        disableEqualOverflow
        spacing={3}
      >
        <Grid xs={12}>
          <TitleButton label={t(tokens.nav.overview)} />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewSingle 
            value={tmsObj.total}
            title="Chấm công mới"
            imgIcon="/assets/iconly/iconly-glass-chart.svg"
            button="Chi tiết"
            onClicked={() => {
              if (tmsObj.total > 0) {
                nextNavigate(
                  router, {},
                  paths.tms.details,
                  paths.tms.index,
                  tmsObj.list,
                );
              }else{
                toastMessage('Chưa có chấm công mới!');
              }
            }} />
        </Grid>
  
        <Grid xs={12} md={4}>
          <OverviewSingle 
            value={fuelObj.total}
            title="Nhiên liệu mới"
            imgIcon="/assets/iconly/iconly-glass-paper.svg"
            button="Chi tiết"
            onClicked={() => {
              if (fuelObj.total > 0) {
                nextNavigate(
                  router, {},
                  paths.fuels.details,
                  paths.fuels.index,
                  fuelObj.list,
                );
              }else{
                toastMessage('Chưa có nhiên liệu mới!');
              }
            }} />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewSingle 
            value={repairObj.total}
            title="Bảo dưỡng mới"
            imgIcon="/assets/iconly/iconly-glass-tick.svg"
            button="Chi tiết"
            onClicked={() => {
              if (repairObj.total > 0) {
                nextNavigate(
                  router, {},
                  paths.repairs.details,
                  paths.repairs.index,
                  repairObj.list,
                );
              }else{
                toastMessage('Chưa có bảo dưỡng mới!');
              }
            }} />
        </Grid>
      </Grid>
    </PageSection>
  );
};

export default Page;
